<template>
  <div>
    <CInput
        v-model="newItem"
        :placeholder="placeholder"
        @keyup.enter="addItem"
        class="mb-2"
        @keydown="onKeydown"

    />
    <div class="d-flex flex-wrap">
      <CBadge
          v-for="(item, index) in value"
          :key="index"
          :color="badgeColor"
          shape="rounded-pill"
          class="mr-2 mb-2 d-flex align-items-center"
          style="font-size: 0.9rem; padding: 0.4rem 0.6rem; cursor: default;"
      >
        {{ item }}
        <span
          style="margin-left:0.3rem; cursor:pointer;"
            @click.stop="removeItem(index)"
        >
          <CIcon name="cil-x-circle" style="width: 1rem; height: 1rem;"/>
        </span>
      </CBadge>

    </div>
  </div>
</template>

<script>
import { CInput, CBadge, CIcon } from '@coreui/vue'

export default {
  name: 'BadgeInput',
  components: { CInput, CBadge, CIcon },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Add New item...',
    },
    badgeColor: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      newItem: '',
    }
  },
  methods: {
    addItem() {
      const val = this.newItem.trim()
      if (val && !this.value.includes(val)) {
        this.$emit('input', [...this.value, val])
        this.newItem = ''
      }
    },
    removeItem(index) {
      const newArr = this.value.slice()
      newArr.splice(index, 1)
      this.$emit('input', newArr)
    },
    onKeydown(event) {
      if (event.key === 'Enter' || event.key === ',' ) {
        event.preventDefault()
        this.newItem = this.newItem.replace(/[, ]+$/, '')
        this.addItem()
      }
    },
  },
}
</script>
